export default "__VITE_ASSET__Cm9aWEOW__"